// each preset turns a firebase id token into the headers one backend expects.
// supporting a new auth contract means adding a preset here, never adding another
// request function next to apiRequest.
const AUTH_PRESETS = {
  // portal rest api (the aws gateway behind oneillmarketingapi.com / sunshinelifehealthapi.com)
  aws: token => ({ authorization: `token ${token}` }),
  // zoho SafePortalProxy endpoints, which expect the token in two headers
  zohoProxy: token => ({
    authorization: `auth ${token}`,
    token: `auth ${token}`
  }),
  // firebase cloud functions
  bearer: token => ({ Authorization: `Bearer ${token}` }),
  // unauthenticated calls
  none: () => ({})
};

export default AUTH_PRESETS;

/**
 * whether a preset needs a firebase id token to build its headers
 * @param auth - preset name
 */
export function presetNeedsToken(auth) {
  return auth !== 'none';
}
